import { Taxonomy, TaxonomyNode } from '@treetop/shared/model';

export const convertToTaxonomy = (node: TaxonomyNode): Taxonomy => {
  return { id: node.id, title: node.title, parentId: node.parentId, children: [], organisationId: node.item.organisationId };
};
